module.exports = require('./lib/index');



// WEBPACK FOOTER //
// ./~/react-beautiful-dnd/~/symbol-observable/index.js